import React, { Component } from "react";
import { TextField } from "@rmwc/textfield";
import { connect } from "react-redux";
import EditPriceItem from '../../EditPriceItem/EditPriceItem';
import * as actionCreator from "../../../action/index.js";
import * as validate from "../../Modals/validations";

class ExtraAnchors extends Component {
  render() {
    return (
      <>
        {this.props.const_var.Componentinputs &&
          this.props.const_var.Componentinputs.length > 0 &&
          this.props.const_var.Componentinputs.map((val, index) => {
            return (
              val != null && (
                <>
                  <div className="option-add-remove-item row gutters-5" key={index}>                  
                    <div className='form-group mb-0 col'>
                      <div class="control-label-bar justify-content-between">
                        <div class="control-label-text">Name</div>
                      </div>
                      <div className="floating-label-input">
                        <TextField
                          name="additional_name"
                          autoFocus
                          maxLength={50}
                          value={
                            this.props.const_var.Componentinputs.length > 0 &&
                              this.props.const_var.Componentinputs[index] !=
                              undefined &&
                              this.props.const_var.Componentinputs[index]
                                .additional_name != undefined
                              ? this.props.const_var.Componentinputs[index]
                                .additional_name
                              : ""
                          }
                          onChange={(e) =>
                            this.props.extraItemsAction(
                              e.target.value,
                              "addNewComponent",
                              val,
                              index,
                              "additional_name",
                              "addNewComponent"
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className='form-group mb-0 col-4'>
                      <div class="control-label-bar justify-content-between">
                        <div class="control-label-text">Qty</div>
                        <div class="control-label-action">
                          <div className={(this.props.const_var.loginSession == true) ?"price-box" : "price-box d-none"}>
                            <EditPriceItem anchor={true} updatedPriceDataObj={this.props.lNTBuildingData["updatePriceDataElements"]["centerBuilding"]} is_disabled={(this.props.const_var.Componentinputs.length > 0 && this.props.const_var.Componentinputs[index] != undefined && this.props.const_var.Componentinputs[index].additional_quantity != 0) ? "false" : "true"} jsonObj={'extraitems'} jsonObjValue={(this.props.const_var.Componentinputs.length > 0 && this.props.const_var.Componentinputs[index] != undefined && this.props.const_var.Componentinputs[index].additional_quantity != 0) ? true : false} jsonObjKey={(val.additional_name != null) ? val.additional_name : 0} />
                          </div>
                        </div>
                      </div>                      
                      <div className="floating-label-input">
                        <TextField
                          inputMode="numeric"
                          maxLength="4"
                          value={
                            this.props.const_var.Componentinputs.length > 0 &&
                              this.props.const_var.Componentinputs[index] !=
                              undefined &&
                              this.props.const_var.Componentinputs[index]
                                .additional_quantity != undefined
                              ? this.props.const_var.Componentinputs[index]
                                .additional_quantity
                              : 0
                          }
                          name="additional_quantity"
                          onKeyUp={(e) => validate.numericCheck(e)}
                          onChange={(e) =>
                            this.props.extraItemsAction(
                              e.target.value,
                              "addNewComponent",
                              val,
                              index,
                              "additional_quantity",
                              "addNewComponent"
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className="form-group mb-0 col-auto"
                      onClick={(e) => {
                        this.props.AddandRemoveComponent(
                          e,
                          "remove",
                          index,
                          "addNewComponent"
                        )
                      }
                      }
                    >
                      <div class="control-label-text">&nbsp;</div>
                      <div className="option-action"><i className="icon-delete"></i></div>
                    </div>
                  </div>
                </>
              )
            );
          })}
      </>
    );
  }
}
const mapStoreToProps = (state) => {
  return {...state.reducer, ...state.reducer.const_var};
};
export default connect(mapStoreToProps, actionCreator)(ExtraAnchors);
